export interface ClientTypeParams {
	isDealer: boolean;
	isVE: boolean;
	isSeller: boolean;
	isPF: boolean;
	isPJ: boolean;
}

export enum EClientType {
	Person = 0,
	Organization = 1,
	Collaborator = 2,
	KeyAccount = 3,
	Partner = 4,
	DealerPerson = 5,
	DealerOrganization = 6,
	VAPerson = 7,
	VAOrganization = 8,
	VEKeyAccount = 9,
	VEPerson = 10,
	VEOrganization = 11,
}

export class ShareUserInfo {
	private isDealer: boolean;
	private isSeller: boolean;
	private isVE: boolean;
	private clientType: EClientType;

	constructor(isDealer: boolean, isSeller: boolean, isVE: boolean, clientType: EClientType) {
		this.isDealer = isDealer;
		this.isSeller = isSeller;
		this.isVE = isVE;
		this.clientType = clientType;
	}

	public sendUserInformation(): number | null {
		const params: ClientTypeParams = {
			isDealer: this.isDealer,
			isVE: this.isVE,
			isSeller: this.isSeller,
			isPF: this.clientType === EClientType.Person,
			isPJ: this.clientType === EClientType.Organization,
		};

		try {
			return this.getClientTypeValue(params);
		} catch (error) {
			console.error(error);
			return null;
		}
	}

	getClientTypeValue(params: ClientTypeParams): number | null {
		const { isDealer, isVE, isSeller, isPF, isPJ } = params;

		if (isDealer) {
			if (isPF) return EClientType.DealerPerson;
			if (isPJ) return EClientType.DealerOrganization;
		}

		if (isVE) {
			if (isPF) return EClientType.VEPerson;
			if (isPJ) return EClientType.VEOrganization;
			return EClientType.VEKeyAccount;
		}

		if (isSeller) {
			if (isPF) return EClientType.VAPerson;
			if (isPJ) return EClientType.VAOrganization;
		}

		if (isPF) return EClientType.Person;
		if (isPJ) return EClientType.Organization;

		return null;
	}
}
